import { render } from "./DexDataTable.vue?vue&type=template&id=79dcc88c"
import script from "./DexDataTable.vue?vue&type=script&lang=js"
export * from "./DexDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__